<!-- Circular avatar-shaped badge for displaying a single icon. -->

<script lang="ts" setup>
import { AvatarRoot } from 'reka-ui';

interface Props {
  size?: number;
}

const props = defineProps<Props>();
</script>

<template>
  <AvatarRoot
    :class="css.avatarRoot"
    :style="{ '--avatar-size': props.size ? `${props.size}px` : undefined }"
  >
    <slot />
  </AvatarRoot>
</template>

<style lang="scss" module="css">
$avatar-size: 48px;

.avatarRoot {
  // Define component-specific CSS variables
  --avatar-background: #{$color-doctor-600};
  --avatar-icon-color: #{$color-white};

  border-radius: 50%;
  background: var(--avatar-background);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  user-select: none;
  width: var(--avatar-size, $avatar-size);
  height: var(--avatar-size, $avatar-size);
  flex: 0 0 var(--avatar-size, $avatar-size);

  > svg {
    color: var(--avatar-icon-color);
    padding: 25%;
    width: 100%;
    height: 100%;
  }
}
</style>
